import {COMPANY_PANEL} from "app/config/urls/prefixes";
const prefix = `${COMPANY_PANEL}/conversations`;


export const conversationRoutes = {
  'pc.conversations': `${prefix}`,
  'pc.conversations.messages': (id=':chatId') => `${prefix}/${id}`
};
